import React from "react";
import MyMainHeading from "../../app/components/Text/MyMainHeading";
import MyParagraph from "../../app/components/Text/MyParagraph";
import MySubHeading from "../../app/components/Text/MySubHeading";
import TextWallContainer from "../../app/components/Text/TextWallContainer";
import Vcontainer from "../../app/components/Vcontainer/Vcontainer";

export default function AboutStreamerFeatures(props) {
  return (
    <Vcontainer maxW='960px' margin='auto'>
      <TextWallContainer>
        <MyMainHeading>About: Features</MyMainHeading>
        <MySubHeading mt='30px' size='md'>
          Features
        </MySubHeading>
        <MyParagraph>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
          ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
          sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
          et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
          takimata sanctus est Lorem ipsum dolor sit amet.
        </MyParagraph>
      </TextWallContainer>
    </Vcontainer>
  );
}
